import React, { useState, useRef, useEffect, useMemo } from "react";
import { addData, deleteData, editData, getData } from "../../controllers/studentEvents.controller";

import moment from "moment";
import DatePicker from "react-datepicker";

import toast from 'react-hot-toast';
import {
    IconPlus,
} from "@tabler/icons-react";
import { RiListRadio, RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import Button from "../../Components/Button";
import Page from "../../Components/Page";
import { useNavigate } from "react-router-dom";
import StudentEventsEdit from "./StudentEvents_Edit";
const StudentEvents = () => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [image, setImage] = useState(null);
    const [imageFields, setImageFields] = useState([{ file: null }]);

    const handleImageUpload = (index, file) => {
        const updatedFields = [...imageFields];
        updatedFields[index].file = file;
        setImageFields(updatedFields);
    };


    const handleRemoveField = (id) => {
        setImageFields(imageFields.filter((field) => field.id !== id));
    };
    const [formData, setFormData] = useState({
        event_name: "",
        description: "",
        date: null,  // Initialize as null
        location: "",
        file: null,
    });


    const [toggles, setToggles] = useState([
        { label: 'Add New', icon: <IconPlus />, isToggled: false },
        { label: 'List', icon: <RiListRadio />, isToggled: true },
    ]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };





    // get
    const fetchTableData = async () => {
        const res = await getData({})
        console.log('res => ', res)

        if (res.status === 200) {
            const apiData = res?.data?.data;
            const tableData = apiData?.map((d) => ({
                ...d,
                date: moment.utc(d.date).format("YYYY-MM-DD HH:mm"), // Convert to local time and format
            }))
            setData(tableData)
        }
    }

    useEffect(() => {
        fetchTableData()

    }, [])

    const formatISODateForInput = (date) => {
        if (!date) return '';  // Check if date is null or undefined

        try {
            return moment(date).format('YYYY-MM-DD HH:mm'); // Format using moment
        } catch (error) {
            console.error("Error formatting date:", error);
            return '';
        }
    };




    // add
    const addNewPublication = async () => {
        try {
            const { event_name, description, date, location } = formData;
            //console.log("form data ...........",formData)
            if (!event_name || !description || !date || !location || imageFields.every((field) => !field.file)) {
                toast.error("Please fill in all the required fields and upload a document.");
                return;
            }

            toast.loading("Submitting your data...");
            const frmData = new FormData();
            frmData.append("event_name", event_name);
            frmData.append("description", description);
            frmData.append("date", moment(date).format("YYYY-MM-DD HH:mm:ss"));  //Include time in the format
            frmData.append("location", location);

            imageFields.forEach((field) => {
                if (field.file) {
                    frmData.append("file", field.file);
                }
            });

            const res = await addData(frmData);

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);

                setFormData({
                    event_name: "",
                    description: "",
                    date: "",
                    location: "",
                    // file: null,

                });
                // clear all the fields after  saved
                setImageFields([{ file: null }]);

                fetchTableData()
            } else {
                toast.error(message || "Failed to add research data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding research data:", error);


            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };

    const handleAddMore = () => {
        setImageFields([...imageFields, { id: Date.now(), file: null }]);
    };

    // edit
    const editBtn = async () => {
        try {
            const { event_name, date, file, location, description, } = formData;

            if (!event_name || !date || !file || !location || !description) {
                toast.error("Please fill in all the required fields and upload a document.");
                return;
            }

            toast.loading("Submitting your data...");


            const res = await editData({
                id: selectedRowId,
                event_name,
                date: moment(date).format("YYYY-MM-DD HH:mm:ss"),
                file,
                location,
                description,

            });

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);
                setFormData({

                    event_name: "",
                    date: "",
                    location: "",
                    description: "",
                    file: null,

                });

                document.getElementById("modal-edit").close()
                fetchTableData()
            } else {
                toast.error(message || "Failed to add research publication data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding research data:", error);


            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };


    // delete
    const deletePBtn = async () => {
        try {
            if (selectedRowId) {
                toast.loading("Please wait...");
                const res = await deleteData({ id: selectedRowId })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    fetchTableData()
                    setSelectedRowId(null)
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }

    const handleToggle = (index) => {
        setToggles((prevToggles) =>
            prevToggles.map((toggle, i) => ({ ...toggle, isToggled: i === index }))
        );
    };

    const toggeledIndex = useMemo(() => {
        return toggles.findIndex((d) => d.isToggled)
    }, [toggles])




    // add images to the table
    // const addPartnerDetails = async () => {
    //     try {

    //         toast.loading("plaese wait");
    //         const res = await addData({ file: selectedFile })
    //         const message = res.data.message;
    //         toast.dismiss();
    //         if (res.status === 200) {
    //             toast.success(message);
    //             setImage(null);

    //             fetchTableData()

    //         }
    //         else {
    //             toast.error(message);
    //         }

    //     } catch (error) {
    //         console.log(error);
    //         const message = error?.response?.data?.message || "something went wrong";
    //         toast.dismiss();
    //         toast.error(message);
    //     }
    // }


    return (
        <Page className="px-8 py-6">
            <div className='flex items-center gap-10 text-xl'>
                <div className="text-[#100f13]">
                    Research & Student Life / Student Life /  <span className="text-[#0f0e0e] bg-white mt-6">Student Events</span>
                </div>
            </div>
            <div className="flex flex-wrap gap-4 mt-4">
                {toggles.map((toggle, index) => (
                    <div key={toggle.id} className="flex flex-col items-center">

                        <Button styles={'h-100'} outlined={!toggle.isToggled} onClick={() => handleToggle(index)}>
                            <span className="flex flex-row items-center justify-center w-[150px]">{toggle.icon} {toggle.label}</span>
                        </Button>

                    </div>

                ))}
            </div>

            <div className="w-full p-6 mx-auto mt-10 bg-white rounded-lg shadow-lg">
                {toggeledIndex === 1 ? (
                    <div>
                        <h1 className="text-xl font-bold mb-2 text-[#4B465C] mt-6">Event List</h1>

                        <table className="w-full bg-white border-collapse rounded-lg shadow-md">
                            <thead>
                                <tr className="bg-gray-100 text-[#4B465C]">
                                    <th className="w-1/4 px-4 py-2 text-center">Name</th>
                                    <th className="w-1/4 px-4 py-2 text-center">Date </th>

                                    <th className="w-1/4 px-4 py-2 text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={item.event_id} className="border-b hover:bg-gray-50">
                                        <td className="px-4 py-2 text-center">{item.event_name}</td>
                                        <td className="px-4 py-2 text-center">{item.date}</td>

                                        <td className="px-4 py-2 text-center">
                                            <div className="flex justify-center gap-4">
                                                <button
                                                    onClick={() => {
                                                        setSelectedRowId(item.event_id)
                                                        document.getElementById("modal-delete").showModal();
                                                    }}
                                                    className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                >
                                                    Delete
                                                    <RiDeleteBin2Line className="ml-2" />
                                                </button>

                                                <button onClick={() => {
                                                    console.log('item data => ', item)
                                                    // navigate('/sab/student-events-edits')// prev 1
                                                    navigate(`/sab/student-events-edits`
                                                        , {
                                                            state: { item }, // Pass item as state
                                                        });



                                                    // setSelectedRowId(item.id)
                                                    // setFormData((prevState) => ({
                                                    //     ...prevState,
                                                    //     event_name: item.title,
                                                    //     date: item.date,
                                                    //     location: item.location,
                                                    //     file: item.file,
                                                    //     description: item.description

                                                    // }))
                                                    // document.getElementById("modal-edit").showModal();

                                                }} className="px-3 py-1 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md flex items-center gap-1">
                                                    Edit
                                                    <FiEdit />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                ) : (
                    <div>
                        <h1 className="mb-6 text-2xl font-bold">Add Event</h1>
                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="flex items-start gap-6">
                                <div className="mb-4">
                                    <label htmlFor="event_name" className="block mb-2 text-gray-600">
                                        Event Name
                                    </label>
                                    <input
                                        type="text"
                                        id="event_name"
                                        name="event_name"
                                        value={formData.event_name}
                                        onChange={handleChange}
                                        className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                    />
                                </div>
                               
                                <div>
                                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="date-picker">
                                        Date
                                        </label>
                                        <input
                                            id="date-picker"
                                            name="date-picker"
                                            type="datetime-local"
                                             value={formData.date ? formatISODateForInput(formData.date) : ''} //Conditional formatting
                                            onChange={(e) => {
                                                setFormData({ ...formData, date: e.target.value });
                                            }}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                    </div>
                            </div>

                            {/* <div className="mb-4">
                                <label htmlFor="file" className="block text-sm font-medium text-gray-700">
                                    Upload Images
                                </label>
                                <div className="flex items-center gap-4 mt-1">
                                    <input
                                        type="text"
                                        value={formData.file ? formData.file.name : ""}
                                        readOnly
                                        placeholder="No file selected"
                                        className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                    />
                                    <label
                                        htmlFor="file"
                                        className="px-3 py-2 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md cursor-pointer"
                                    >
                                        Browse File
                                    </label>
                                    <input
                                        type="file"
                                        id="file"
                                        name="file"
                                        onChange={handleFileChange}
                                        className="hidden"
                                    />
                                </div>
                            </div> */}


                            {/* Image Upload Fields */}
                            <div className="space-y-4"> {/* Added spacing between image upload fields */}
                                {imageFields.map((field, index) => (
                                    <div key={field.id} className="flex items-center space-x-4">
                                        <div className="flex-1">
                                            <label className="block text-gray-700">Upload Image {index + 1}</label>
                                            <div className="flex items-center mt-2 space-x-4">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    value={field.file ? field.file.name : ""}
                                                    placeholder="No file selected"
                                                    className="w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-md cursor-not-allowed focus:outline-none"
                                                />
                                                <label
                                                    htmlFor={`upload-image-${field.id}`}
                                                    className="px-4 py-2 text-white bg-[#92288C] rounded-md shadow cursor-pointer hover:bg-[#6C0B67]"
                                                >
                                                    Browse Image
                                                </label>
                                                <input
                                                    type="file"
                                                    id={`upload-image-${field.id}`}
                                                    accept="image/*"
                                                    onChange={(e) => handleImageUpload(index, e.target.files[0])}
                                                    className="hidden"
                                                />
                                                {imageFields.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveField(field.id)}
                                                        className="text-sm text-red-600 hover:underline"
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Add More Button */}
                            <button
                                type="button"
                                onClick={handleAddMore}
                                className="mt-4 text-sm text-[#92288C] hover:underline"
                            >
                                Add more
                            </button>

                            <div className="mb-4">
                                <label htmlFor="location" className="block text-sm font-medium text-gray-700">
                                    Location
                                </label>
                                <input
                                    type="text"
                                    id="location"
                                    name="location"
                                    value={formData.location}
                                    onChange={handleChange}
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="description" className="block text-sm font-medium text-gray-700">
                                    Description
                                </label>
                                <textarea
                                    type="text"
                                    id="description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                            </div>

                            <div className="flex justify-end space-x-4">
                                <button
                                    type="button"
                                    className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md"
                                    onClick={() => { handleToggle(1) }}
                                >
                                    Cancel
                                </button>

                                <button
                                    type="button"
                                    onClick={addNewPublication}
                                    className="px-4 py-2 bg-[#92288C] text-white rounded-md"
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                )
                }
            </div>
            <dialog
                id="modal-edit"
                className="modal modal-bottom xl:modal-middle inset-0 z-50 rounded-lg w-[600px]"
            >
                <div className="p-6">
                    <h1 className="mb-6 text-2xl font-bold">Edit Event</h1>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <div className="flex items-start gap-6">
                            {/* Event Name Input */}
                            <div className="flex-1">
                                <label htmlFor="event_name" className="block mb-2 text-gray-600">
                                    Event Name
                                </label>
                                <input
                                    type="text"
                                    id="event_name"
                                    name="event_name"
                                    value={formData.event_name}
                                    onChange={handleChange}
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                            </div>
                            {/* Date Picker */}
                            <div className="relative flex-1">
                                <label className="block mb-2 text-gray-600" htmlFor="date-picker">
                                    Date
                                </label>
                                <div
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg cursor-pointer focus:ring-2 focus:ring-blue-500"
                                    id="date-picker"
                                >
                                    {/*<DatePicker
                                        selected={formData.date}
                                        onChange={(date) => {
                                            setSelectedDate(date);
                                            setFormData({ ...formData, date });
                                        }}
                                        dateFormat="yyyy-MM-dd HH:mm"
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        className="w-full outline-none"
                                        placeholderText="Select Date and Time"
                                    />*/}

                                     <input
                                            id="date-picker"
                                            name="date-picker"
                                            type="datetime-local"
                                            value={formData.date ? formatISODateForInput(formData.date) : ''} //Conditional formatting
                                            onChange={(e) => {
                                                setFormData({ ...formData, date: e.target.value });
                                            }}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                        />
                                </div>
                            </div>
                        </div>

                        <div className="mb-4">
                            <label htmlFor="file" className="block text-sm font-medium text-gray-700">
                                Upload Documents
                            </label>
                            <div className="flex items-center gap-4 mt-1">
                                <input
                                    type="text"
                                    value={formData.file ? formData.file.name : ""}
                                    readOnly
                                    placeholder="No file selected"
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                                <label
                                    htmlFor="file"
                                    className="px-3 py-2 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md cursor-pointer"
                                >
                                    Browse File
                                </label>
                                <input
                                    type="file"
                                    id="file"
                                    name="file"
                                    onChange={(e) => setFormData({ ...formData, file: e.target.files[0] })}
                                    className="hidden"
                                />
                            </div>
                        </div>

                        <div className="mb-4">
                            <label htmlFor="location" className="block text-sm font-medium text-gray-700">
                                Location
                            </label>
                            <input
                                id="location"
                                name="location"
                                value={formData.location}
                                onChange={handleChange}
                                className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="description" className="block text-sm font-medium text-gray-700">
                                Description
                            </label>
                            <textarea
                                id="description"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                rows="4"
                                className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                            />
                        </div>

                        <div className="flex justify-end space-x-4">
                            <button
                                type="button"
                                className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md"
                                onClick={() => {
                                    document.getElementById("modal-edit").close()
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={editBtn}
                                className="px-4 py-2 bg-[#92288C] text-white rounded-md"
                            >
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </dialog>



            <dialog
                id="modal-delete"
                className="inset-0 z-50 rounded-lg modal modal-bottom sm:modal-middle"
            >

                <div className="relative z-10 w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                    <div className="text-center">
                        <h2 className="text-xl font-bold text-gray-900">
                            Delete
                        </h2>
                        <p className="font-bold text-gray-500">
                            Are you sure?
                        </p>
                    </div>


                    <div className="flex justify-center mt-4 space-x-4">
                        <button
                            onClick={() => {
                                setSelectedRowId(null)
                                document.getElementById("modal-delete").close()
                            }}
                            className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                        >
                            No
                        </button>
                        <button
                            onClick={async () => { deletePBtn(); }}
                            className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                        >
                            Yes
                        </button>
                    </div>
                </div>
            </dialog>


        </Page>



    );
};

export default StudentEvents;